<template>
  <div v-bind:class="{ 'op--modal-container': true, hide: !locationInput.show }" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="card small-margin-v-s" @click.stop>
          <h3 class="margin-v-z">{{ $t('rsvpEdit.typeLocation', {location: locType}) }}</h3>
          <a class="close-btn" href="javascript:;" @click="close"><i class="fa fa-times-circle"></i></a>
          <input class="field-text" type="text" 
            :placeholder="placeholder"
            v-model="queryText" @keyup="query" ref="RsvpEditLocationTextInput" />
          <span class="remove-extra-stop" v-if="locationInput.isStop"
            @click="removeExtraStop">[{{ $t('rsvpEdit.removeExtraStop') }}]</span>
          <div class="suggestions-container" v-show="suggestions.length > 0">
            <div class="suggestions">
              <div class="suggestion" 
                v-for="(suggestion, index) in suggestions" :key="index"
                @click="selectLocation(index)">
                <div class="title">{{ suggestion.title }}</div>
                <div class="subtitle">{{ suggestion.subtitle }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import ApiQuote from '@/modules/api/edit-quote'
const request = require('browser-request')
export default {
  name: 'location-input',
  data () {
    return {
      queryText: '',
      suggestions: []
    }
  },
  computed: {
    locationInput () { return this.$store.state.rsvpEdit.locationInput },
    show () { return this.$store.state.rsvpEdit.locationInput.show },
    locType () {
      if (this.locationInput.isStop) {
        return this.$t('rsvpEdit.extraStop2')
      }
      return this.locationInput.isPickup ? this.$t('rsvpEdit.pickup') : this.$t('rsvpEdit.dropoff')
    },
    placeholder () {
      if (this.locationInput.isStop) {
        return this.$t('rsvpEdit.extraStop')
      }
      return this.locationInput.isPickup ? this.$t('rsvpEdit.pickupLocation') : this.$t('rsvpEdit.dropoffLocation')
    },
    charter () { return this.$store.state.reservation.charter }
  },
  methods: {
    close () { this.$store.commit('rsvpEdit/hideLocationInput') },
    query () {
      let self = this
      if (self.queryText === '') {
        self.suggestions = []
        return
      }
      let restrictedTypes = [
        'locality', 'postalCodePoint', 'administrativeArea',
        'chainQuery', 'categoryQuery'
      ]

      let suggestedLoc = { lat: 33.942791, lng: -118.410042 } // LAX
      if (window.location.href.indexOf('primetimeshuttle') > -1 &&
        (self.$store.state.brandId === 15 || self.$store.state.brandId === 6)
      ) {
        suggestedLoc = { lat: 13.4451379, lng: -89.0592244 } // El Salvador
      }
      let pickup = self.$store.state.rsvpEdit.editedRsvp.pickup
      if (!self.locationInput.isPickup && pickup.lat) {
        suggestedLoc = { lat: pickup.lat, lng: pickup.lng }
      }

      if (self.queryText.length >= 3) {
        let url = 'https://autosuggest.search.hereapi.com/v1/autosuggest?at={AT}&q={SEARCH}&apiKey={API_KEY}'
        url = url.replace('{AT}', encodeURIComponent(suggestedLoc.lat + ',' + suggestedLoc.lng))
          .replace('{SEARCH}', self.queryText)
          .replace('{API_KEY}', CONFIG.hereApi.key)
        request.get({
          url: url,
          json: true
        }, function (err, res, body) {
          if (err || body.items.length === 0) {
            self.suggestions = [{
              icon: 'fa-exclamation-triangle',
              title: self.$t('rsvpEdit.sorry'),
              subtitle: self.$t('rsvpEdit.couldntLocate') + ' "' + self.queryText + '"'
            }]
            return
          }

          let result = []
          body.items.forEach(function (prediction) {
            if (restrictedTypes.indexOf(prediction.resultType) === -1) {
              let subtitle = prediction.address.label
              result.push({
                id: prediction.id,
                title: prediction.title,
                subtitle: subtitle,
                icon: 'fa-map-marker'
              })
            }
          })

          self.suggestions = result.slice(0, 5)
        })
      }
    },
    selectLocation (index) {
      let self = this
      let place = self.suggestions[index]

      if (!place.id) { return }
      let url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}'
      url = url.replace('{LOCATION_ID}', place.id)
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) return

        let result = body
        let lat = result.position.lat
        let lng = result.position.lng
        let finalResult = {
          title: result.title,
          address1: result.address.street || result.title,
          address2: result.address.houseNumber || result.address.district,
          addressLine1: result.address.street || result.title,
          addressLine2: result.address.houseNumber || result.address.district,
          city: result.address.city,
          state: result.address.state,
          zip: result.address.postalCode,
          country: result.address.countryCode,
          lat: lat,
          lng: lng,
          geofenceId: -1,
          geofenceName: null,
          geofenceType: null
        }

        if (self.charter.enabled) {
          self.$store.commit('rsvpEdit/setEditedPickup', finalResult)
          self.$store.commit('reservation/setCharterData', {pickup: finalResult})
        } else if (self.locationInput.isStop) {
          self.$store.commit('rsvpEdit/setEditedStop', {
            index: self.locationInput.stopIndex,
            value: finalResult
          })
        } else {
          let mutation = self.locationInput.isPickup ? 'rsvpEdit/setEditedPickup' : 'rsvpEdit/setEditedDropoff'
          self.$store.commit(mutation, finalResult)
        }
        self.$store.commit('rsvpEdit/setSelectedService', null)
        ApiQuote.getQuote(self)
      })

      self.suggestions = []
      self.queryText = ''
      self.close()
    },
    removeExtraStop () {
      this.$store.commit('rsvpEdit/removeExtraStop', this.locationInput.stopIndex)
      this.close()
      ApiQuote.getQuote(this)
    }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }
      let self = this
      setTimeout(function () {
        self.$refs.RsvpEditLocationTextInput.focus()
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  max-width: 500px;
  margin: 0 auto;
  position: relative;
}

.field-text {
  margin: 10px 0 0;
}

.remove-extra-stop{
  color: #d55151;
  margin-top: 8px;
  display: inline-block;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #777 !important;
}

.suggestions-container {
  width: 100%;
  position: absolute;
  top: 98px;
  left: 0;

  & .suggestions {
    margin: 0 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  }

  & .suggestion {
    padding: 10px 15px;
    border-top: 1px solid rgba(0,0,0,0.15);
    cursor: pointer;
    background-color: #fff;
    transition: all 250ms;
    -webkit-transition: all 250ms;

    &:hover {
      background-color: #f5f5f5;
    }

    & .title {
      font-size: 16px;
      line-height: 16px;
    }

    & .subtitle {
      margin-top: 3px;
      font-size: 12px;
      line-height: 12px;
      color: #555;
    }
  }
}
</style>



// WEBPACK FOOTER //
// LocationInput.vue?37dc3851